// extracted by mini-css-extract-plugin
export default {"wrapper":"TopBar_wrapper__-qwM9","layoutsSelect":"TopBar_layoutsSelect__TYlvv","links":"TopBar_links__6p95-","link":"TopBar_link__YLN5l"};